module.exports = __webpack_public_path__ + "static/img/miBookPro.ab57e6a2.png";